'use strict';

exports.__esModule = true;
exports.Subheader = undefined;

var _Subheader2 = require('./Subheader');

var _Subheader3 = _interopRequireDefault(_Subheader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Subheader3.default;
exports.Subheader = _Subheader3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Subheaders/index.js
// module id = 243
// module chunks = 79611799117203 213534597649335